/*
 * File: position.js
 * Project: interactive-city-app
 *
 * Created by Brendan Michaelsen on November 6, 2023 at 11:40 AM
 * Copyright © 2023 Lithios, LLC. All rights reserved.
 *
 * Last Modified: November 6, 2023 at 11:40 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Utilities
 */

export const scrollPageTo = (x, y, options = {}) => {
	if (typeof window !== 'undefined') {
		window.scroll({ top: y, left: x, ...options });
	}
};
